/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import UniversalTracker, { UniversalTrackerType } from './UniversalTracker';
import { UniversalTrackerValuePlain } from '../types/surveyScope';
import { UniversalTrackerModalServiceUtrv } from '../reducers/universal-tracker-modal';
import { ExistingEvidenceFile } from '../components/survey/question/questionInterfaces';
import { UserMin } from '../constants/users';
import { Tab } from '../components/utr-modal/ContentTabs';

class UniversalTrackerModalService {
  universalTracker: UniversalTracker;
  initiativeId?: string;
  universalTrackerValues?: UniversalTrackerModalServiceUtrv[];
  documents: ExistingEvidenceFile[] = [];
  users: UserMin[] = [];
  currentValue?: Pick<UniversalTrackerValuePlain, '_id' | 'initiativeId' | 'history'>;
  currentValueId?: string;
  activeTabId?: Tab['navId'];

  constructor(data: any, type = UniversalTrackerType.Utr) {
    this.universalTracker = new UniversalTracker(data, type);
    this.documents = data.documents || [];
    this.users = data.users || [];
    if (type === UniversalTrackerType.Frameworks) {
      this.setUniversalTrackerValues(data.universalTrackerValues);
    }
  }

  setUniversalTrackerValues(utrvs: UniversalTrackerModalServiceUtrv[] | undefined) {
    this.universalTrackerValues = utrvs;
  }

  getUniversalTracker() {
    return this.universalTracker;
  }

  setInitiativeId(initiativeId: string | undefined) {
    this.initiativeId = initiativeId;
  }

  getInitiativeId() {
    if (this.initiativeId) {
      return this.initiativeId;
    }
    const currentValue = this.getCurrentValue();
    if (currentValue) {
      return (this.initiativeId = currentValue.initiativeId);
    }
  }

  getUniversalTrackerValues() {
    return this.universalTrackerValues || [];
  }

  getActiveTabId() {
    return this.activeTabId;
  }

  setActiveTabId(activeTabId?: Tab['navId']) {
    this.activeTabId = activeTabId;
  }

  universalTrackerValuesLoaded() {
    return Array.isArray(this.universalTrackerValues);
  }

  setCurrentValueId(universalTrackerValueId: string) {
    this.currentValueId = universalTrackerValueId;
  }

  setCurrentValue(value: Pick<UniversalTrackerValuePlain, '_id' | 'initiativeId'>) {
    this.setCurrentValueId(value._id);
    this.currentValue = value;
  }

  private getCurrentValue() {
    if (this.currentValue) {
      return this.currentValue;
    }

    if (!this.currentValueId) {
      return;
    }

    const utrv = this.universalTrackerValues?.find((utrv) => utrv._id === this.currentValueId);
    if (!utrv) {
      return;
    }

    return (this.currentValue = utrv);
  }
}

export default UniversalTrackerModalService;
